// extracted by mini-css-extract-plugin
export var externalLink = "_cf-0";
export var internalLinkLabel = "_cf-1";